import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PreferenceModel extends ModeModelBase {
  override _name = 'preference';
  override belongsTo = 'account';
  override parentIdAttribute = 'username';
  override attributes = [
    { name: 'editor_theme', default: 'light' },
    { name: 'editor_layout', default: 'vertical' },
    { name: 'editor_browser_enabled', default: true },
    { name: 'features', default: {} },
    { name: 'home_view', default: 'reports' },
    { name: 'home_list_type', default: 'tile' },
    { name: 'hidden_banners', default: {} },
    { name: 'notebook_sidebar', default: {}, type: 'text' },
    { name: 'display_table_enabled', default: false },
    { name: 'sql_editor_preferences', default: {} },
  ];
}

@Injectable({ providedIn: 'root' })
export class PreferenceModelAccessor extends ModelAccessorBase<PreferenceModel> {
  override name = 'preference';
  override parentModel = 'account';
  override parentIdAttribute = 'username';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.preference');
  }

  createModel(resource, opts?) {
    const model = new PreferenceModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
